import { defineMessages } from 'react-intl';

export default defineMessages({
  title: { defaultMessage: 'Purchase {PHIAT} on {DEX}' },
});
